import React from 'react';
import { Box } from '@common-fe/common-fe';

import LettersOfMedicalNecessityList from './LettersOfMedicalNecessityList/LettersOfMedicalNecessityList';

const LettersOfMedicalNecessity = () => {
  return (
    <Box data-testId="lmn-tab">
      <LettersOfMedicalNecessityList />
    </Box>
  );
};

export default LettersOfMedicalNecessity;
